import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Input } from '../../../components/input'
import { InputWrapper } from '../../../components/input/input.style'
import { Button } from '../../../components/button'
import { InfoBlock, InfoBlockText } from '../../../styles/auth'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'

const AccountChangePasswordScreen = () => {
    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container>
                    <MainContent>
                        <Heading>
                            Change Password
                        </Heading>
                        {/* TODO: BREADCRUMB */}
                        <Breadcrumb
                            crumbs={['account', 'change password']}
                        />
                        <InfoBlock>
                            <img src="/assets/images/checkIcon.webp" alt="check icon" />
                            <InfoBlockText>Please Note that you cannot change your password until after 24 hours of first attempting to change it, Keep this in mind.</InfoBlockText>
                        </InfoBlock>
                        <form>
                            <InputWrapper>
                                <Input
                                    id="newPassword"
                                    label="New password"
                                    type="text"
                                    placeholder="New Password"
                                    fullWidth
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Input
                                    id="confirmPassword"
                                    label="Confirm Password"
                                    type="text"
                                    placeholder="Confirm Password"
                                    fullWidth
                                />
                            </InputWrapper>

                            <Button
                                type="submit"
                                style={{ marginLeft: 'auto' }}
                                variant="secondary"
                                responsive
                            >
                                SAVE CHANGES
                            </Button>
                        </form>
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper>
    )
}

export default AccountChangePasswordScreen
